import { request } from './client';

export const apiUpdateProfile = (data) =>
  request('/users/profile', { method: 'PUT', body: data });
